import { SVG } from './styled';
export function MagnifyingGlassInBadgeSvg() {
    return (<SVG width="247" height="203" viewBox="0 0 247 203" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
      <g opacity="0.6">
        <g opacity="0.5">
          <g opacity="0.5">
            <g filter="url(#filter0_f_2973_239)">
              <ellipse rx="41.1215" ry="30.6245" transform="matrix(0.987978 0.154597 -0.417026 0.908894 98.185 78.7511)" fill="#FFB673"/>
            </g>
            <g filter="url(#filter1_f_2973_239)">
              <ellipse rx="22.6357" ry="16.8575" transform="matrix(0.987978 0.154597 -0.417026 0.908894 172.623 68.8857)" fill="#85C1F5"/>
            </g>
            <g filter="url(#filter2_f_2973_239)">
              <ellipse rx="29.0491" ry="21.6338" transform="matrix(0.987978 0.154597 -0.417026 0.908894 164.773 101.52)" fill="#6966F2"/>
            </g>
          </g>
          <g opacity="0.5">
            <g filter="url(#filter3_f_2973_239)">
              <ellipse rx="26.1039" ry="48.2429" transform="matrix(0.417026 0.908894 -0.987978 0.154597 99.2866 89.9097)" fill="#FFB673"/>
            </g>
            <g filter="url(#filter4_f_2973_239)">
              <ellipse rx="14.3691" ry="26.5557" transform="matrix(0.417026 0.908894 -0.987978 0.154597 151.135 122.623)" fill="#85C1F5"/>
            </g>
            <g filter="url(#filter5_f_2973_239)">
              <ellipse rx="18.4404" ry="34.0798" transform="matrix(0.417026 0.908894 -0.987978 0.154597 98.8149 134.971)" fill="#6966F2"/>
            </g>
          </g>
        </g>
      </g>
      <g filter="url(#filter6_d_2973_239)">
        <rect x="93" y="63" width="64" height="64" rx="12" fill="white"/>
      </g>
      <g clipPath="url(#clip0_2973_239)">
        <path d="M134.543 102.332L129.867 97.6562C129.28 98.5273 128.529 99.2789 127.657 99.866L132.333 104.542C132.943 105.152 133.933 105.152 134.543 104.542C135.152 103.934 135.152 102.941 134.543 102.332Z" fill="#6966F2"/>
        <path opacity="0.4" d="M123.09 85C118.638 85 115 88.6379 115 93.125C115 97.6121 118.638 101.25 123.09 101.25C127.542 101.25 131.215 97.6121 131.215 93.125C131.215 88.6379 127.613 85 123.09 85ZM123.09 98.125C120.333 98.125 118.09 95.882 118.09 93.125C118.09 90.368 120.333 88.125 123.09 88.125C125.847 88.125 128.09 90.368 128.09 93.125C128.09 95.8828 125.883 98.125 123.09 98.125Z" fill="#6966F2"/>
      </g>
      <defs>
        <filter id="filter0_f_2973_239" x="5.58594" y="0.193604" width="185.197" height="157.115" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="25" result="effect1_foregroundBlur_2973_239"/>
        </filter>
        <filter id="filter1_f_2973_239" x="99.1738" y="3.16602" width="146.897" height="131.439" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="25" result="effect1_foregroundBlur_2973_239"/>
        </filter>
        <filter id="filter2_f_2973_239" x="84.6807" y="31.3468" width="160.185" height="140.347" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="25" result="effect1_foregroundBlur_2973_239"/>
        </filter>
        <filter id="filter3_f_2973_239" x="0.385742" y="15.0328" width="197.802" height="149.754" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="25" result="effect1_foregroundBlur_2973_239"/>
        </filter>
        <filter id="filter4_f_2973_239" x="74.2168" y="58.9296" width="153.836" height="127.388" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="25" result="effect1_foregroundBlur_2973_239"/>
        </filter>
        <filter id="filter5_f_2973_239" x="14.2705" y="67.3973" width="169.089" height="135.147" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="25" result="effect1_foregroundBlur_2973_239"/>
        </filter>
        <filter id="filter6_d_2973_239" x="85" y="59" width="80" height="80" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="4"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.372122 0 0 0 0 0.326944 0 0 0 0 0.445833 0 0 0 0.1 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2973_239"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2973_239" result="shape"/>
        </filter>
        <clipPath id="clip0_2973_239">
          <rect width="20" height="20" fill="white" transform="translate(115 85)"/>
        </clipPath>
      </defs>
    </SVG>);
}
